import { render, staticRenderFns } from "./RMCard.vue?vue&type=template&id=1a358c66&lang=pug&"
import script from "./RMCard.vue?vue&type=script&lang=js&"
export * from "./RMCard.vue?vue&type=script&lang=js&"
import style0 from "./RMCard.vue?vue&type=style&index=0&id=1a358c66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports